// extracted by mini-css-extract-plugin
export default {"container":"confirmOrder_container__NShI6","content":"confirmOrder_content__ekZHV","btnBox":"confirmOrder_btnBox__UAdwW"};